module.exports = __webpack_public_path__ + "static/media/Soft skills.e47bb16a.jpg";